<template>
  <CTag theme="outline">
    <CColor :theme>
      <CIcon name="radio-urgency-on" :size="20"/>
      {{ $t('jobs.checklist') }}
    </CColor>
  </CTag>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import CColor from '@/shared/components/CColor.vue';
  import CIcon from '@/shared/components/CIcon.vue';
  import CTag from '@/shared/components/CTag.vue';
  import Severity from '@/shared/constants/Severity';

  const props = defineProps<{
    status: Severity;
  }>();

  const theme = computed(() => {
    switch (props.status) {
      case Severity.GOOD:
        return 'success';
      case Severity.CAUTION:
        return 'warning';
      case Severity.BAD:
        return 'danger';
    }
  });
</script>
